// extracted by mini-css-extract-plugin
export default {"root":"BlockTestimonial_root__tgf5E","media":"BlockTestimonial_media__dx-ll","text":"BlockTestimonial_text__pQVOu","testimonial":"BlockTestimonial_testimonial__fH1kh"};